import VideoElement from './components/VideoElement/VideoElement'
const videoElements = [...document.querySelectorAll('[data-video-element="video"]')]
for (let videoElement of videoElements) {
  new VideoElement(videoElement)
}